<template>
     <div :class="data.class" class="freehtml" v-html="data.html"></div>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
}
</script>